import { DetailCreation, DetailQuestion, Answer } from '../../../../../../service/actionPlans/actionPlanById'

export const getQuestionData = (detailCreation?: DetailCreation, detailQuestions?: DetailQuestion[]) => {
  const detailQuestion = detailQuestions?.[0]

  return {
    questionText: detailQuestion?.questionName ?? detailCreation?.question ?? '',
    answers: detailQuestion?.answers ?? detailCreation?.answers ?? [],
    typeQuestionId: detailCreation?.typeQuestionId,
    questionnaire: detailCreation?.questionnaire,
    sectionName: detailQuestion?.sectionName ?? detailCreation?.section,
  }
}
